import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import CarRow from '../CarRow';
import styles from './SRP.scss';

const SRP = (props) => {
  const { cars, configType } = props;

  if (configType === 'standalone') {
    return (
      <div className={styles.pageBody}>
        <div className="uar-standalone-product-credit-application"></div>
      </div>
    );
  } else {
    return (
      <div className={styles.pageBody}>
        {cars &&
          cars.map((car) => (
            <CarRow car={car} configType={configType} key={car.id} />
          ))}
      </div>
    );
  }
};

SRP.propTypes = {
  cars: PropTypes.array,
  configType: PropTypes.string,
};

export default withRouter(SRP);
